var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockinBckgrIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 323,
    viewBox: "0 0 408 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.499 445.123L340.979 196.066C349.188 187.701 362.493 187.701 370.702 196.066L456.047 283.001C464.257 291.366 464.257 304.922 456.047 313.287L211.567 562.344C203.358 570.709 190.053 570.709 181.844 562.344L96.499 475.409C88.2894 467.044 88.2894 453.487 96.499 445.123Z",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.001 -66.6059L39.1247 374.378C31.0497 382.609 17.976 382.609 9.90098 374.378L-75.9438 286.924C-84.0187 278.694 -84.0187 265.368 -75.9438 257.157L356.914 -183.827C364.989 -192.058 378.062 -192.058 386.137 -183.827L471.982 -96.3728C480.057 -88.1427 480.057 -74.8168 471.982 -66.6059H472.001Z",
    fill: "#1da193"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockinBckgrIconBlue);
export default __webpack_public_path__ + "static/media/clockin_bckgr_icon_blue.3fae03cad8c67eb6f325fc912dfaf9d6.svg";
export { ForwardRef as ReactComponent };